import { handleActions } from 'redux-actions';
import * as types from './types';

const initialState = {
  displayMessage: false,
  messageContent: null,
  messageType: null,
  navigationEvent: null,
  globalLoading: false,
  currentHomeView: 'default',
  globalBasket: [],
  quotationBasket: [],
  mountQuotations: [],
  globalPaymentData: null,
  globalSelectedMount: null,
  displayModalEffectCreation: false,
  theme: {
    logo: '',
    primaryColor: '#53b297',
    buttonColor: '#53b297',
    linksColor: '#53b297',
    paypalClientId: null,
  }
}

const uiReducer = handleActions({
  [types.TOGGLE_MESSAGE]: (state, { payload }) => {
    return {
      ...state,
      displayMessage: payload.display,
      messageContent: payload.display ? payload.content : null,
      messageType: payload.display ? payload.type : null,
    }
  },
  [types.TOGGLE_COLLAPSE]: (state, { payload }) => {
    return {
      ...state,
      collapsedSider: payload
    }
  },

  [types.TOGGLE_GLOBAL_LOADER]: (state) => {
    return {
      ...state,
      globalLoading: !state.globalLoading
    }
  },

  [types.SET_CURRENT_HOME_VIEW]: (state, {payload}) => {
    return {
      ...state,
      currentHomeView: payload
    }
  },

  [types.SET_GLOBAL_BASKET]: (state, {payload}) => {
    return {
      ...state,
      globalBasket: payload
    }
  },

  [types.SET_QUOTATION_BASKET]: (state, {payload}) => {
    return {
      ...state,
      quotationBasket: payload
    }
  },

  [types.SET_GLOBAL_PAYMENT_DATA]: (state, {payload}) => {
    return {
      ...state,
      globalPaymentData: payload
    }
  },

  [types.SET_GLOBAL_SELECTED_MOUNT]: (state, {payload}) => {
    return {
      ...state,
      globalSelectedMount: payload
    }
  },

  [types.SET_MOUNT_QUOTATIONS]: (state, {payload}) => {
    return {
      ...state,
      mountQuotations: payload
    }
  },

  [types.TOGGLE_MODAL_EFFECT_CREATION]: (state, {payload}) => {
    return {
      ...state,
      displayModalEffectCreation: payload
    }
  },

  [types.SET_THEME]: (state, {payload}) => {
    return {
      ...state,
      theme: payload
    }
  },

  [types.RESET_UI_ENV]: (state) => {
    return initialState
  }
}, initialState);

export default uiReducer;
